import {
  AlertState,
  AlertState as AlertStateShadow,
} from '@eppendorf/vnls-device-service-utils';
import { HasClassName, Tooltip, TooltipProps } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';

import { AlertStatus } from '$features/monitoring/alert-status/alert-status';

function isAlert(maybeAlert: string | undefined): maybeAlert is AlertState {
  if (!maybeAlert || !Object.keys(AlertState).includes(maybeAlert)) {
    return false;
  }

  return maybeAlert === AlertState.Alert || maybeAlert === AlertState.Warn;
}

export interface UnitAlertStateProps extends HasClassName {
  aggregateAlertState?: AlertStateShadow | null;
  side: TooltipProps['side'];
}

export function UnitAlertState({
  aggregateAlertState,
  className,
  side,
}: UnitAlertStateProps): ReactElement {
  if (aggregateAlertState) {
    if (isAlert(aggregateAlertState)) {
      return <AlertStatus className={className} alertStatus={aggregateAlertState} />;
    }
  }

  return (
    <Tooltip
      trigger={
        <div role="status" aria-label="no-alerts" className="circle circle--green" />
      }
      side={side}
    >
      OK
    </Tooltip>
  );
}
